import React from 'react';
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import WelcomePage from "./pages/WelcomePage";
import ChooseImage from "./pages/ChooseImage";
import Parameters from "./pages/Parameters";
import HardPrompts from "./pages/HardPrompts";
import Prompt from "./pages/Prompt";
import DebugAllStates from "./pages/DebugAllStates";
import Result from "./pages/Result";
import { useState } from "react";

function App() {
  const [language, setLanguage] = useState("en");
  const [image, setImage] = useState(null);
  const [result, setResult] = useState([]);
  const [guid, setGuid] = useState(null);
  // const [imageUrl, setImageUrl] = useState(null);
  const [parameters, setParameters] = useState({
    guessMode: true, // TODO: what is fuck is this?
    ddimSteps: 25,
    seed: 0,
    strength: 1.0, // TODO: what is fuck is this?
    valueThreshold: 0.1,
    imageResolution: 512,
    detectResolution: 512,
    distanceThreshold: 0.1,
    scale: 9,
    eta: 0, // TODO: what is fuck is this?
  });
  const [hardPrompts, setHardPrompts] = useState({
    a_prompt:
      "best quality, extremely detailed, 8k, cinematic , photorealistic",
    n_prompt:
      "longbody, lowres, bad anatomy, bad hands, missing fingers, extra digit, fewer digits, cropped, worst quality, low quality",
  });
  const [prompt, setPrompt] = useState({
    prompt: "...",
  });

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <WelcomePage language={language} setLanguage={setLanguage} />
          }
        />
        <Route
          path="/image"
          element={
            <ChooseImage
              image={image}
              setImage={setImage}
              language={language}
            />
          }
        />
        <Route
          path="/parameters"
          element={
            <Parameters parameters={parameters} setParameters={setParameters} />
          }
        />

        <Route
          path="/hardprompts"
          element={
            <HardPrompts
              hardPrompts={hardPrompts}
              setHardPrompts={setHardPrompts}
            />
          }
        />
        <Route
          path="/prompt"
          element={
            <Prompt prompt={prompt} setPrompt={setPrompt} language={language} />
          }
        />
        <Route
          path="/debug"
          element={
            <DebugAllStates
              setGuid={setGuid}
              image={image}
              parameters={parameters}
              hardPrompts={hardPrompts}
              prompt={prompt}
              setPrompt={setPrompt}
              setResult={setResult}
              language={language}
            />
          }
        />
        <Route
          path="/result"
          element={
            <Result
              guid={guid}
              result={result}
              image={image}
              parameters={parameters}
              hardPrompts={hardPrompts}
              prompt={prompt}
              language={language}
            />
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
